'use client';

import { useRouter } from 'next/navigation';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import { Format } from '../../../../lib/dateFns';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { formatDateCommon } from '../../../../utils/formatters';
import type { TradeRequest } from '../../types';
import LotteryDrawButton from '../LotteryDrawButton/LotteryDrawButton';
import styles from './TradeRequestList.module.scss';

export type TradeRequestListProps = {
  tradeRequestList: Array<TradeRequest>;
  lotteryId: string;
};

function TradeRequestList({ tradeRequestList, lotteryId }: TradeRequestListProps) {
  const router = useRouter();

  const handleDetailClick = (tradeRequestId: string) => {
    //@ts-ignore
    router.push(`/trade/${lotteryId}/history/${tradeRequestId}`);
  };

  return (
    <ul className={`${styles.tradeCollectionList} `}>
      {tradeRequestList.map((tradeRequest, index) => (
        <li key={`${tradeRequest.event.id}-${tradeRequest.tradeRequestId}-${index}`}>
          <div className={`${styles.itemCard}`}>
            <div className={`${styles.itemDetailWrapper} ${utilsStyles.mtXSmall}`}>
              <div className={styles.itemImage}>
                <ImageView alt={tradeRequest.event.name} src={tradeRequest.event.imageUrl} isFreeSize={true} />
              </div>
              <div className={`${styles.itemDetail} ${utilsStyles.mlSmall}`}>
                <div className={styles.itemNameWrapper}>
                  <p className={`${styles.itemName} ${utilsStyles.textBold} ${utilsStyles.textXLarge}`}>
                    {tradeRequest.event.name}
                  </p>
                </div>
                <div className={`${styles.itemNameWrapper} ${utilsStyles.mtXSmall}`}>
                  <p className={utilsStyles.textSmall}>交換申請ID：{tradeRequest.tradeRequestId}</p>
                  <p className={utilsStyles.textSmall}>
                    取消可能日時：{formatDateCommon(tradeRequest.tradeAt, Format.dateTimeLotteryJa)}まで
                  </p>
                </div>
                <div className={`${utilsStyles.mtXSmall}`}>
                  <button
                    className={styles.detailButton}
                    type='button'
                    onClick={() => handleDetailClick(tradeRequest.tradeRequestId)}
                  >
                    詳細を確認
                  </button>
                </div>
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default TradeRequestList;
